import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import useUser from '../user/userController';
import useResetPasswordController from './resetPasswordController';

const useResetPageController = () => {
  const theme = useTheme();

  const { tryResetPassword, validatePassword } = useUser();
  const code = useSearchParams()[0].get('code')?.replaceAll(' ', '+');
  const buttonRef = useRef<HTMLButtonElement>(null);

  const {
    newPassword,
    handleConfirmPasswordInput,
    handleNewPasswordInput,
    validationConfirmPassword,
    onValidateNewPassword,
    validationNewPassword,
    onValidateConfirmPassword,
  } = useResetPasswordController();

  const validateNewPassword = async (
    newPassword: Password
  ): Promise<string> => {
    const result = await validatePassword(
      {
        code: code!,
        password: newPassword,
      },
      () => {}
    );
    if (result) return '';
    return theme.texts.pleaseEnterANewPassword;
  };

  const validateConfirmPassword = async (
    confirmPassword: Password
  ): Promise<string> => {
    if (newPassword !== confirmPassword) return theme.texts.passwordsDoNotMatch;
    return '';
  };

  const sendResetPasswordRequest = () => {
    return tryResetPassword({
      code: code!,
      password: newPassword,
    });
  };

  return {
    newPassword,
    handleConfirmPasswordInput,
    handleNewPasswordInput,
    validationConfirmPassword,
    onValidateNewPassword,
    validationNewPassword,
    validateConfirmPassword,
    onValidateConfirmPassword,
    validateNewPassword,
    sendResetPasswordRequest,
    buttonRef,
  };
};

export default useResetPageController;
